import type { Prisma } from '@prisma/client'

export default (status: 'active' | 'expired' = 'active'): Prisma.HeatProtectionContactWhereInput => {
  if (status === 'expired') {
    return {
      dataConsentExpiresAt: { lt: new Date().getFullYear() },
    }
  }
  return {
    dataConsentExpiresAt: { gte: new Date().getFullYear() },
  }
}
